import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../../../shared/services/base.service';
import { Evaluation } from '../models/evaluation.model';

@Injectable()
export class ProductService extends BaseService {
  controllerName = "ApiECommerceInventory";
  urlGetById = "GetItemById";
  urlAddEvaluation = "AddEvaluation";
  urlUpdateEvaluation = "UpdateEvaluation";
  urlGetAllItemTypes = "GetAllItemTypes";
  urlGetitemtypebyid = "GetItemTypeById";
  urlGetRequiredItemTypeAttribute = "GetRequiredItemTypeAttribute";
/////////////////////////////////////////////////////////////////
public header = new HttpHeaders().set(
  "access-token",
   localStorage.getItem("jwt")
);
/////////////////////////////////////////////////////////////////
  getById(id: number): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetById}?itemId=${id}`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getAllItemTypes(): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetAllItemTypes}?Start=-1&End=0&searchValue=&orderby=&dir=`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  getItemTypeById(itemTypeId: number): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetitemtypebyid}?id=${itemTypeId}`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
  GetRequiredItemTypeAttribute(itemTypeId: number): any {
    return this._http.get(`${this.baseUrl}api/${this.controllerName}/${this.urlGetRequiredItemTypeAttribute}?itemTypeId=${itemTypeId}`,{headers:this.header});
  }
/////////////////////////////////////////////////////////////////
AddEvaluation(evaluation: Evaluation): any {
  return this._http.post(`${this.baseUrl}api/${this.controllerName}/${this.urlAddEvaluation}`,evaluation,{headers:this.header});
}
/////////////////////////////////////////////////////////////////
UpdateEvaluation(evaluation: Evaluation): any {
  return this._http.post(`${this.baseUrl}api/${this.controllerName}/${this.urlUpdateEvaluation}`,evaluation,{headers:this.header});
}

}